import User from 'domain/entity/user';
import getGenericUseCase from 'use-case/genericUseCase';

const readUsersUseCase = getGenericUseCase<User[], null>((client) => client(null));

export default readUsersUseCase;
